import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';

export type LessonEditRunningScheduleWarningVariant = 'term_group' | 'camp';

export interface LessonEditRunningScheduleWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  variant: LessonEditRunningScheduleWarningVariant;
  /** Used when variant is term_group — shown in the description when provided */
  termName?: string;
  onContinue: () => void;
}

export function LessonEditRunningScheduleWarningDialog({
  open,
  onOpenChange,
  variant,
  termName,
  onContinue,
}: LessonEditRunningScheduleWarningDialogProps) {
  const label = termName?.trim() || 'This term';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Edit running schedule?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm text-muted-foreground">
              {variant === 'camp' ? (
                <p>
                  You are updating a camp that is currently running. Changes may affect students and families
                  who are already enrolled.
                </p>
              ) : (
                <p>
                  You are updating a lesson for <span className="font-medium text-foreground">{label}</span>, which is
                  active and currently in session. Changes may affect students and families who are already enrolled.
                </p>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button">Cancel</AlertDialogCancel>
          <Button
            type="button"
            variant="default"
            onClick={() => {
              onContinue();
              onOpenChange(false);
            }}
          >
            Continue editing
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
